import './SearchTextBox.scss';

export { default } from './SearchTextBox';
